import styled, { css } from "styled-components";
import { Theme } from "@informed-innovations/components";

export const FakeButton = styled.a`
    border-radius: 3px;
    padding: 9px 10px;
    border: none;
    text-decoration: none;
    cursor: pointer;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    min-height: 44px;

    background-color: white;
    color: ${Theme.colors.blue};
    border: 1px solid ${Theme.colors.blue};

    text-decoration: none !important;

    ${props =>
        props.width &&
        css`
            width: ${props.width};
        `}
    ${props =>
        props.outline &&
        css`
            border: 1px solid ${props.outline};
        `}
     @media only screen and (min-width: 360px) {
        min-width: 275px;
    }

    ${props =>
        !props.disabled &&
        css`
            &:hover {
                background-color: ${Theme.colors.gray[200]};
            }
        `}
    ${props =>
        props.disabled &&
        css`
            background-color: ${Theme.colors.gray[400]};
            cursor: default;
            color: ${Theme.colors.gray[700]};
            border: none;
        `}
`;
